import { render, staticRenderFns } from "./room-control.vue?vue&type=template&id=aa331d9c&"
import script from "./room-control.vue?vue&type=script&lang=ts&"
export * from "./room-control.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports